module.exports = __webpack_public_path__ + "img/DAVID_CANNON_01-rs.4bbbf509.jpg";